module.exports = __webpack_public_path__ + "static/logo-speaker-836456075886f8442c7000eb69c6b0f9.png";